import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import Posts from './pages/Posts';
import About from './pages/About';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import MoreInfo from './pages/moreInfo';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Navbar/>
      <div className="App">
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/services" component={Services}/>
          <Route path="/posts" component={Posts}/>
          <Route path="/about" component={About}/>
          <Route path="/contact" component={Contact}/>
          <Route path="/careers" component={Careers}/>
          <Route path="/more-info/:id" component={MoreInfo}/>
        </Switch>
      </div>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
